/**
 * Duração da pausa em curso, no formato `m:ss` (ou `h:mm:ss` acima de uma
 * hora). Devolve `null` quando o início não é conhecido — pausa declarada pelo
 * motor (issue #450) sem `started_at`, porque foi iniciada em outra sessão ou
 * dispositivo. Nesse caso o indicador aparece sem contador; inventar "0:00"
 * afirmaria que a pausa começou agora.
 */
export function formatBreakElapsed(startedAt: string | null, now: number): string | null {
  if (!startedAt) return null;
  const start = new Date(startedAt).getTime();
  if (isNaN(start)) return "0:00";
  const sec = Math.max(0, Math.floor((now - start) / 1000));
  const h = Math.floor(sec / 3600);
  const m = Math.floor((sec % 3600) / 60);
  const s = sec % 60;
  const mm = String(m).padStart(2, "0");
  const ss = String(s).padStart(2, "0");
  return h > 0 ? `${h}:${mm}:${ss}` : `${m}:${ss}`;
}
